import { get, post } from "../../utils/axiosInstance";

const BASE_URL = "/rest/market-inventory";
const SHIPMENTS_BASE_URL = "/rest/shipments";

// Locations API
export const fetchLocations = () => {
  const url = `${SHIPMENTS_BASE_URL}/locations/`;
  return get(url);
};

// Stock Management APIs
export const scanItem = (data) => {
  const url = `${BASE_URL}/stock/scan_item/`;
  return post(url, data);
};

export const fetchStockLevels = (locationId, lowStockOnly = false) => {
  let url = `${BASE_URL}/stock/stock_levels/`;
  const params = new URLSearchParams();
  if (locationId) params.append('location_id', locationId);
  if (lowStockOnly) params.append('low_stock_only', 'true');
  if (params.toString()) url += `?${params.toString()}`;
  return get(url);
};

export const fetchStockItems = (locationId, itemId, activeOnly = true, checkExpiring = null) => {
  let url = `${BASE_URL}/stock/`;
  const params = new URLSearchParams();
  if (locationId) params.append('location_id', locationId);
  if (itemId) params.append('item_id', itemId);
  if (activeOnly !== null) params.append('active_only', activeOnly);
  if (checkExpiring) params.append('check_expiring', checkExpiring);
  if (params.toString()) url += `?${params.toString()}`;
  return get(url);
};

export const processShipment = (shipmentReportId) => {
  const url = `${BASE_URL}/stock/process_shipment/`;
  return post(url, { shipment_report_id: shipmentReportId });
};

// Alerts APIs
export const fetchAlerts = (locationId, alertType, activeOnly = true) => {
  let url = `${BASE_URL}/alerts/`;
  const params = new URLSearchParams();
  if (locationId) params.append('location_id', locationId);
  if (alertType) params.append('alert_type', alertType);
  if (activeOnly !== null) params.append('active_only', activeOnly);
  if (params.toString()) url += `?${params.toString()}`;
  return get(url);
};

export const resolveAlert = (alertId) => {
  const url = `${BASE_URL}/alerts/${alertId}/resolve/`;
  return post(url, {});
};

export const checkExpiringItems = (locationId, daysAhead = 7) => {
  const url = `${BASE_URL}/alerts/check_expiring/`;
  const body = { days_ahead: daysAhead };
  if (locationId) body.location_id = locationId;
  return post(url, body);
};

// Consumption & Reports APIs
export const fetchConsumptionHistory = (locationId, fromDate, toDate) => {
  let url = `${BASE_URL}/consumption/`;
  const params = new URLSearchParams();
  if (locationId) params.append('location_id', locationId);
  if (fromDate) params.append('from_date', fromDate);
  if (toDate) params.append('to_date', toDate);
  if (params.toString()) url += `?${params.toString()}`;
  return get(url);
};

export const fetchConsumptionReport = (locationId, groupBy = 'day', fromDate, toDate, itemId) => {
  let url = `${BASE_URL}/consumption/consumption_report/`;
  const params = new URLSearchParams();
  if (locationId) params.append('location_id', locationId);
  if (groupBy) params.append('group_by', groupBy);
  if (fromDate) params.append('from_date', fromDate);
  if (toDate) params.append('to_date', toDate);
  if (itemId) params.append('item_id', itemId);
  if (params.toString()) url += `?${params.toString()}`;
  return get(url);
};

export const generateDailySummary = (locationId, date) => {
  const url = `${BASE_URL}/summary/generate_summary/`;
  return post(url, { location_id: locationId, date: date });
};

// Adjust stock (for manual inventory adjustments)
export const adjustStock = (data) => {
  const url = `${BASE_URL}/stock/adjust_stock/`;
  return post(url, data);
};